var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    overflow: "hidden",
    preserveAspectRatio: "xMidYMid meet",
    id: "eaf-cc09-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eaf-cc09-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 30
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url('#eaf-cc09-1')",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#513c6a",
    width: 19,
    height: 25,
    rx: 4,
    transform: "matrix(1 0 0 1.0519 2.5 1.8513)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6f7fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7 22.2621l10 0m-7.9146 -3.9669l6 0m-4.8852 -10.1322c0 2.4 3.6 2.4 3.6 0c0 -2.4 -3.6 -2.4 -3.6 0zm5.7998 6.2c0 -4.3333 -8 -4.3333 -8 0l8 0z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "12 15",
    to: "12 15",
    calcMode: "discrete",
    dur: "1000ms",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;0.001;0.005;0.012;0.023;0.033;0.047;0.108;0.122;0.133;0.144;0.17;0.184;0.188;0.195;0.228;0.243;0.254;0.283;0.298;0.309;0.339;0.353;0.364;0.405;0.419;0.456;0.5;0.6;1",
    calcMode: "linear",
    dur: "1000ms",
    fill: "freeze",
    attributeName: "transform",
    values: "1 1;0.9747 0.9747;0.9539 0.9539;0.9374 0.9374;0.9238 0.9238;0.9163 0.9163;0.911 0.911;0.898 0.898;0.8901 0.8901;0.88 0.88;0.9184 0.9184;1.0795 1.0795;1.1221 1.1221;1.1225 1.1225;1.1122 1.1122;0.9937 0.9937;0.9744 0.9744;0.9844 0.9844;1.049 1.049;1.0622 1.0622;1.0575 1.0575;1.0208 1.0208;1.0127 1.0127;1.0147 1.0147;1.0377 1.0377;1.0372 1.0372;1.0278 1.0278;1.03 1.03;1 1;1 1",
    type: "scale",
    additive: "sum"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "-12 -15",
    to: "-12 -15",
    calcMode: "discrete",
    dur: "1000ms",
    fill: "freeze",
    additive: "sum"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.4d5b536551d072b9ac5a22542d9af0bb.svg";
export { ForwardRef as ReactComponent };